var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{class:`${_vm.scopeId}`},[_c(`protokol-power-app-template-${_vm.app.uuid}`,_vm._g(_vm._b({tag:"component",attrs:{"config":_vm.app.config}},'component',_vm.$attrs,false),_vm.$listeners))],1),_c('b-alert',{attrs:{"show":_vm.errorModal.show,"variant":"danger"}},[_vm._v("\n        "+_vm._s(_vm.errorModal.msg)+"\n    ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }